import AppsList from "components/AppsList";
import Text from "components/Brand/Text";
import EPButton from "components/UI/EPButton";
import Loader from "components/UI/Loader";
import { useFavoriteGames } from "hooks/swr/useFavoriteGames";
import useService from "hooks/useService";
import React, { useEffect } from "react";
import { GameService } from "service/GameService";
import { AppsData } from "data/AppsData";
function FavoriteGames({ max }) {
  const { data, error, mutate, isLoading } = useFavoriteGames();

  const maxLimit = max || data?.length;

  if (!data)
    return (
      <div>
        <Loader />
      </div>
    );
  if (!data?.length)
    return (
      <div className="flex flex-col items-center justify-center gap-4">
        <Text justify={false} className="text-center">
          No favorite games yet.
        </Text>
        <EPButton href="/">Explore Games</EPButton>
      </div>
    );

  return <AppsList apps={data.slice(0, maxLimit)} favorite />;
}

export default FavoriteGames;
